(() => {
  const updateWhatsAppLinks = () => {
    const links = document.querySelectorAll('[data-aura-whatsapp-link]');
    if (!links.length) return;

    links.forEach((link) => {
      const numberMatch = link.href.match(/wa\.me\/([^?]+)/);
      const number = numberMatch ? numberMatch[1] : '';
      if (!number) return;

      const baseMessage = link.dataset.baseMessage || 'Hello Aura team, I would like to enquire about';
      const title = document.querySelector('.aura-product__title')?.textContent?.trim() || '';
      const message = `${baseMessage} ${title} - ${window.location.href}`;
      link.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    });
  };

  const initAccordions = () => {
    document.querySelectorAll('[data-aura-product-accordions]').forEach((group) => {
      if (group.dataset.auraReady === 'true') return;
      group.dataset.auraReady = 'true';

      const oneOpen = group.dataset.oneOpen === 'true';
      group.addEventListener('toggle', (event) => {
        const target = event.target;
        if (!oneOpen || target.tagName !== 'DETAILS' || !target.open) return;
        group.querySelectorAll('details[open]').forEach((details) => {
          if (details !== target) details.removeAttribute('open');
        });
      }, true);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    updateWhatsAppLinks();
    initAccordions();
  });

  document.addEventListener('variant:changed', updateWhatsAppLinks);
  document.addEventListener('shopify:section:load', () => {
    updateWhatsAppLinks();
    initAccordions();
  });
})();
